import { Order } from "../../../entity/Order";
import { Method, ROUTES, URLs } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { fetchAPIRealtime } from "../../configuration/MainServiceRealtime";
import { OrderDto } from "../../dto/Order.Dto";
import { mapToOreders } from "../../mapper/OrderMapper";

export class WSOrder {
  private static instance: WSOrder;
  private constructor() {}

  /**
   * Singleton instance
   */
  public static getInstance(): WSOrder {
    if (!WSOrder.instance) {
      WSOrder.instance = new WSOrder();
    }
    return WSOrder.instance;
  }

  async getAllOrders(storeId: string): Promise<Order[]> {
    try {
      const url = `${ROUTES.ORDERS}${storeId}`;

      const response = await fetchAPI<OrderDto[]>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });
      return mapToOreders(response.data);
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async createOrder(order: Order): Promise<string> {
    try {
      const url = `${ROUTES.ORDERS}${ROUTES.CREATE_ORDER}`;

      const response = await fetchAPI<string>({
        url,
        method: Method.POST,
        params: order,
        isAuthenticated: true,
      });

      return response.data;
    } catch (error) {
      console.error("Create order failed:", error);
      throw error;
    }
  }

  async deleteOrder(id: string): Promise<void> {
    try {
      const url = `${ROUTES.ORDERS}${ROUTES.DELETE_ORDER}`;

      await fetchAPI<string>({
        url,
        method: Method.POST,
        params: { id: id },
        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Delete order failed:", error);
      throw error;
    }
  }

  async updateOrder(order: Order): Promise<string> {
    try {
      const url = `${ROUTES.ORDERS}${ROUTES.UPDATE_ORDER}`;

      const response = await fetchAPI<string>({
        url,
        method: Method.PUT,
        params: order,
        isAuthenticated: true,
      });
      if (response.ok) {
        return response.data;
      } else throw "Faild to update order" + response.data;
    } catch (error) {
      console.error("Update order failed:", error);
      throw error;
    }
  }

  getAllOrdersRealtime(
    storeId: string,
    onOrdersChange: (orders: Order[]) => void,
    onError?: (error: any) => void,
  ) {
    try {
      const url = `${ROUTES.ORDERS}realtime/${storeId}`;

      const unsubscribe = fetchAPIRealtime<OrderDto[]>({
        url,
        isAuthenticated: true,

        onMessage: (data) => {
          const orders = mapToOreders(data);
          onOrdersChange(orders);
        },

        onError: (error) => {
          console.error("Realtime orders failed:", error);
          onError?.(error);
        },

        onOpen: () => {
          console.log("Realtime orders connected");
        },
      });

      return unsubscribe;
    } catch (error) {
      console.error("Get realtime orders failed:", error);
      throw error;
    }
  }

  /**
   * This function call a function in the backend to update the order status based on delivery companies responses
   * @param storeId - Store ID
   * @returns Promise<void>
   */
  async updateStatus(storeId: string): Promise<void> {
    try {
      const url = `${ROUTES.ORDERS}${ROUTES.UPDATE_ORDER_STATUS}${storeId}`;

      await fetchAPI<string>({
        url,
        method: Method.GET,

        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Update order status failed:", error);
      throw error;
    }
  }
}
